module.exports = __webpack_public_path__ + "img/goods2_1.dfe608d8.jpg";